import {registerJQueryComponent} from '@lib/JQueryRegistry'
import hasParentWithClassName from '@lib/hasParentWithClassName'

export default class Dropdown {
    constructor(rootElement) {
        this.$dom = {
            root: rootElement,
            body: rootElement.find('.dropdown-body'),
            button: rootElement.find('.dropdown-button'),
            items: rootElement.find('.dropdown-item').toJQueryObjectsArray(),
            window: $(window)
        }

        this.$state = {
            open: false
        }

        this.$dom.window.click(this.onWindowClick)
        this.$dom.button.click(this.onButtonClick)
        this.$dom.items.forEach(item => {
            item.click(() => this.onItemClick(item))
        })
    }

    onButtonClick = () => {
        if (this.$state.open) {
            this.close()
        } else {
            this.open()
        }
    }

    onItemClick = item => {
        this.close()
        this.$dom.root.trigger('dropdown.change', item)
    }

    onWindowClick = e => {
        if (this.$state.open) {
            if (!hasParentWithClassName(e.target, 'dropdown')) {
                this.close()
            }
        }
    }

    open() {
        this.$dom.root.addClass('dropdown--open')
        this.$dom.button.addClass('active')
        this.$dom.body.show()

        this.$state.open = true
    }

    close() {
        this.$dom.root.removeClass('dropdown--open')
        this.$dom.button.removeClass('active')
        this.$dom.body.hide()

        this.$state.open = false
    }
}

registerJQueryComponent(Dropdown, '.dropdown:not(.dropdown--react)')